import { createContext } from "react";

const authContext = createContext({
  isAuth: false,
  onChangeIsAuth: () => null,
  onLogout: () => null,
});

export default authContext;
